import { render, staticRenderFns } from "./cgwView.vue?vue&type=template&id=3a3c178a&scoped=true&"
import script from "./cgwView.vue?vue&type=script&lang=js&"
export * from "./cgwView.vue?vue&type=script&lang=js&"
import style0 from "./cgwView.vue?vue&type=style&index=0&id=3a3c178a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3c178a",
  null
  
)

export default component.exports